import {dateTime} from "services/date";
import {Beacon} from "types/Beacon";

/**
 * Transform the given beacon by deserializing object properties
 *
 * @internal
 * @param beacon
 */
export default function deserializeBeacon(beacon: any): Beacon {
    beacon.enabled_at = dateTime(beacon.enabled_at)
    beacon.created_at = dateTime(beacon.created_at)
    beacon.updated_at = dateTime(beacon.updated_at)

    return beacon;
}